module.exports = __webpack_public_path__ + "img/LOGO-DGFII_PDH.d508df37.png";